import React from 'react';

interface ResultsProps {
  sets: number[][];
}

function Results({ sets }: ResultsProps) {
  return (
    <div className="results-container">
      <h2 className="results-title">Generated Numbers</h2>
      <div className="results-grid">
        {sets.map((set, index) => (
          <div key={index} className="result-card">
            <div className="result-header">Set {index + 1}</div>
            <div className="numbers-display">
              {set.map((num, numIndex) => (
                <span key={numIndex} className="number-badge">
                  {num}
                </span>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Results;
